<app-dossier
  eyebrow="Dossier agent // Débriefing"
  [reference]="operation.value()?.codeName ?? null"
>
  @if (debrief.value(); as debrief) {
    <app-page-title
      title="Salle de débriefing"
      [lede]="debrief.elimination ? 'Votre mission est terminée.' : 'Vous avez quitté la mission.'"
    />

    @if (debrief.elimination; as elimination) {
      <app-target-card
        heading="Vous avez été éliminé"
        icon="warning"
        nameLabel="Agent responsable"
        [name]="elimination.by.firstName"
        [aside]="'alias ' + elimination.by.codeName"
        actionLabel="Méthode d'élimination"
        [action]="elimination.action.description"
        stamp="Cible neutralisée"
      />
      <div class="banner">
        <img src="/assets/lock.svg" alt="" />
        <p>
          Votre couverture a été compromise.<br />
          <span class="banner__accent">
            {{ complete() ? "L'opération est terminée." : 'La mission continue sans vous.' }}
          </span>
        </p>
      </div>
    } @else {
      <app-target-card
        heading="Mission abandonnée"
        icon="warning"
        nameLabel="Agent"
        [name]="debrief.firstName"
        [aside]="'alias ' + debrief.codeName"
      >
        <p class="panel__text">
          Votre chasseur a hérité de votre cible. Votre dossier est classé, mais vos états de
          service restent au classement.
        </p>
      </app-target-card>
    }

    <section class="card spaced service" aria-labelledby="service-title">
      <div class="card__header">
        <h2 class="card__title" id="service-title">États de service</h2>
        <span>Agent {{ debrief.codeName }}</span>
      </div>
      <dl class="facts">
        <dt>Cibles neutralisées</dt>
        <dd>{{ score() }}</dd>
        @for (victim of debrief.eliminatedTargets; track victim.codeName) {
          <dt>{{ agentName(victim) }}</dt>
          <dd>{{ victim.eliminatedAt | date: "HH 'h' mm" }}</dd>
        }
      </dl>
    </section>

    @if (operation.value(); as operation) {
      <h2 class="section-label">État de la partie</h2>
      <app-game-status
        [status]="complete() ? 'Terminée' : 'En cours'"
        [done]="complete()"
        [counts]="counts()"
      >
        @if (complete()) {
          Le rapport final est publié.
        } @else {
          La mission est active.<br />{{ counts().inGame }} agents sont toujours en lice.
        }
      </app-game-status>

      @if (complete()) {
        <p class="spaced">
          <a
            class="button button--primary button--block"
            [routerLink]="['/operations', operation.publicId, 'victory']"
          >
            Consulter le rapport final <span class="button__arrow" aria-hidden="true">›</span>
          </a>
        </p>
      }

      <div class="spaced">
        <app-roster
          [entries]="operation.ranking"
          [selfCodeName]="debrief.codeName"
          [count]="counts().inGame + ' / ' + counts().total + ' agents'"
        />
      </div>
    }

    <div class="note">
      <p>Restez discret. Ne révélez rien aux agents encore en jeu.</p>
      <p class="accent">Le rapport final sera publié à la fin de l'opération.</p>
    </div>
  } @else if (loadError(); as message) {
    <app-page-title title="Salle de débriefing" />
    <app-state-panel kind="error" title="Transmission impossible" [message]="message">
      <button
        class="button button--secondary"
        type="button"
        (click)="debrief.reload(); mission.reload()"
      >
        Réessayer
      </button>
    </app-state-panel>
  } @else {
    <app-page-title title="Salle de débriefing" />
    <app-state-panel
      kind="loading"
      title="Liaison avec le QG…"
      message="Récupération de votre dossier."
    />
  }
</app-dossier>
